<!--
 * @Author: lan.h
 * @Date: 2022-02-14 10:01:54
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-16 16:11:54
 * @Description: 动脉网信息流首页
-->
<template>
  <div class="main-index">
    <!-- <Guide></Guide>
    <div class="prompt-content">
      <p>动脉网PC3.0抢先体验：7*24小时情报追踪、结构化认知医疗行业大事、医疗产业资源对接等，<a :href="$store.state.index2_path + '/new'">立即体验</a></p>
    </div> -->
    <!-- <div class="prompt-content">
      <p>NEW！动脉网全新域名</p>
      <a>https://www.vbdata.cn</a>
      <p>正式启用，原网址仍支持访问</p>
    </div> -->
    <div class="main">
      <Spin fix class="index-loading" v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div class="main_lt">
        <!-- banner -->
        <Banner :banner1="banner1" :banner4="banner4" :banner5="banner5"></Banner>
        <!-- 文章筛选 -->
        <div class="index_screen">
          <a class="tag" @click.stop="haddleSelect('')" :class="{on: active_type == ''}">最新</a>
          <a class="tag" v-for="item in categoryList" :key="item.id" @click.stop="haddleSelect(item)" :class="{on: active_type == item.id}">{{item.name}}</a>
          <a @click.stop="haddleSelect('all')" class="all tag" :class="{on: active_type == 'all'}" target="_blank" :href="$store.state.index2_path + '/articleList'">全部文章</a>
        </div>
        <!-- 信息流 -->
        <ul class="special">
          <li v-for="item, index in articleList" v-cloak :key="index">
            <div v-if="item.type == 2">
              <Report :report="item.data" :entityNtag="entity_ntag"></Report>
            </div>
            <div class="card" v-if="item.type == 0 || item.type == 1">
              <Article :item="item" :mediaTag="media_tag" :itemIndex="index" :entityNtag="entity_ntag" :category="article_category"></Article>
            </div>
            <div class="card" v-if="item.type == 3">
              <ThemePro :item="item" :entityNtag="entity_ntag"></ThemePro>
            </div>
            <div class="card" v-if="item.type == 4">
              <Topic :item="item" :entityNtag="entity_ntag"></Topic>
            </div>
            <div v-if="item.type == -1">
              <Entity5 :item="item"></Entity5>
            </div>
            <div v-if="params.category_ids.length == 0 && index == 2">
              <Poster :banner40="banner40" :listtype="0"></Poster>
            </div>
          </li>
        </ul>
        <div class="more_div">
          <div class="over-p" v-if="list_over && !more_loading">已经到底了~</div>
          <Button v-else @click="more()" :loading="more_loading" :class="more_loading ? 'more_loading' : ''">{{more_loading ? '加载中' : '加载更多'}}</Button>
        </div>
      </div>
      <RightModel class="main_rt" ref="right-model">
        <!-- 快讯 -->
        <TopicLive @getTopic="getTopic"></TopicLive>
        <!-- 国内外融资 -->
        <DFinancing pageType="1"></DFinancing>
        <!-- 最新融资 -->
        <LatestFinancing pageType="1"></LatestFinancing>
        <!-- 推荐赛道 -->
        <RCtrack pageType="1"></RCtrack>
        <!-- 活跃赛道 -->
        <Activetrack pageType="1"></Activetrack>
        <!-- 优质报告 -->
        <RCreport pageType="1"></RCreport>
        <!-- 报告图表 -->
        <ReportChart pageType="1"></ReportChart>
        <!-- 热门标签 -->
        <HotTag></HotTag>
        <!-- 热点文章 -->
        <HotArticle pageType="1"></HotArticle>
        <!-- 专栏作者 -->
        <Author></Author>
      </RightModel>
    </div>
  </div>
</template>

<script>
// import Guide from '@/components/Guide'
import ThemePro from './components/ThemePro'
import Entity5 from './components/Entity5'
import Report from './components/Report'
import Article from './components/Article'
import Topic from './components/Topic'
import Poster from './components/Poster'
import Banner from './components/Banner'
import TopicLive from '@/components/vcbeat/TopicLive'
import LatestFinancing from '@/components/vcbeat/LatestFinancing'
import DFinancing from '@/components/vcbeat/DFinancing'
import RCtrack from '@/components/vcbeat/RCtrack'
import Activetrack from '@/components/vcbeat/Activetrack'
import RCreport from '@/components/vcbeat/RCreport'
import ReportChart from '@/components/vcbeat/ReportChart'
import HotTag from '@/components/vcbeat/HotTag'
import HotArticle from '@/components/vcbeat/HotArticle'
import Author from '@/components/vcbeat/Author'
import RightModel from '@/components/RightModel'
import { getBanner, getMeta, indexlist, indexFollow, indexReport } from '../../service'
export default {
  data() {
    return {
      banner_loading: true,
      topic_loading: true,
      banner1: [],
      banner4: {},
      banner5: {},
      banner40: {},
      article_category: [], //文章类型
      entity_ntag: [], //赛道标签元数据
      media_tag: [], //文章标签
      categoryList: [
        { id: "2995", name: "深度" },
        { id: "166", name: "投融资" },
        { id: "1533", name: "创业公司" },
        { id: "2994", name: "大公司" },
        { id: "2998", name: "政策" },
        { id: "539", name: "报告" },
        { id: "3085", name: "直播" }
      ],
      more_loading: true,
      params: {
        page: 1,
        category_ids: [],
        size: 20
      },
      articleList: [],
      entity5: [],
      follow_page: 1,
      content_ids: {},
      active_type: '',
      list_over: false
    }
  },
  computed: {
    loading() {
      return this.banner_loading || this.topic_loading
    }
  },
  created() {
    this.getMeta()
    this.getBanner()
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        this.$refs['right-model'].scrollChange()
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop > (scrollHeight - windowHeight - 300) && !this.more_loading && scrollTop > 0 && this.follow_page < 3 && this.active_type === '') {
          ++this.follow_page
          this.getList()
        }
      }, 10)
    })
  },
  methods: {
    getTopic() {
      this.topic_loading = false
    },
    /**
     * @description: 栏目元数据
     * @param {*}
     * @return {*}
     */
    async getMeta() {
      let res = await getMeta({
        name: ['article_category', 'entity_ntag', 'media_tag']
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'article_category', res.meta.article_category)
        this.$set(this.$data, 'entity_ntag', res.meta.entity_ntag)
        this.$set(this.$data, 'media_tag', res.meta.media_tag)
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 广告位
     * @param {*}
     * @return {*}
     */
    async getBanner() {
      let res = await getBanner({
        position_id: ['1', '2', '3', '4', '5', '40', '36', '37']
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        res.data.forEach(item => {
          if (item.posId == '1' || item.posId == '2' || item.posId == '3'|| item.posId == '36' || item.posId == '37') {
            this.banner1.push(item)
          } else if (item.posId == '4') {
            this.banner4 = item
          } else if (item.posId == '5') {
            this.banner5 = item
          } else if (item.posId == '40') {
            this.banner40 = item
          }
        })
        this.banner_loading = false
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 文章列表
     * @param {*}
     * @return {*}
     */
    async indexlist() {
      this.more_loading = true
      let res = await indexlist(this.params, (error) => {
        this.$message.error('请求错误！')
      })
      this.more_loading = false
      if (res.code == 0) {
        this.articleList = [...this.articleList, ...res.data]
        this.list_over = res.data.length < 20
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 信息流
     * @param {*}
     * @return {*}
     */    
    getList() {
      Promise.all([
        new Promise((resolve) => { this.getIndexReport(resolve) }),
        new Promise((resolve) => { this.getIndexFollow(resolve) })
      ]).then(res => {
        this.$refs['right-model'].scrollChange()
        this.more_loading = false
        if (res[0].code == 0 && res[1].code == 0) {
          let report_data = [...res[0].data]
          if (this.follow_page == 1) {
            res[1].data.data.splice(5, 0, {
              type: 2,
              data: report_data
            })
          } else if (this.follow_page > 1) {
            res[1].data.data.splice(2, 0, {
              type: 2,
              data: report_data
            })
          }
          let data_copy = [...res[1].data.data]
          let num = 1
          res[1].data.data.forEach((item, index) => {
            if ((this.follow_page == 1 && index > 2 && item.entityInfos && item.entityInfos.length > 0) ||
                (this.follow_page > 1  && item.entityInfos && item.entityInfos.length > 0)
            ) {
              item.entityInfos.forEach(m => {
                if (m.type !=3 && this.entity5.length < 5 && this.entity5.findIndex(a => a.id === m.id) == -1) {
                  this.entity5.push(m)
                }
              })
              if (this.entity5.length == 5) {
                data_copy.splice(index + num, 0, {
                  type: -1,
                  entity: this.entity5
                })
                num = num + 1
                this.entity5 = []
              }
            }
          })
          this.articleList = [...this.articleList, ...data_copy]
          this.content_ids = res[1].data.pageNeeds
        } else {
          if (res[0].code != 0) this.$message.error(res[0].msg)
          if (res[1].code != 0) this.$message.error(res[1].msg)
        }
      })
    },
    async getIndexReport(resolve) {
      let res = await indexReport({
        page: this.follow_page
      }, (error) => {
        this.$message.error('请求错误！')
      })
      resolve(res)
    },
    async getIndexFollow(resolve) {
      this.more_loading = true
      let res = await indexFollow({
        page: this.follow_page,
        pageNeeds: this.content_ids,
      }, (error) => {
        this.$message.error('请求错误！')
      })
      resolve(res)
    },
    /**
     * @description: 条件筛选
     * @param {*} a
     * @param {*} b
     * @param {*} type
     * @return {*}
     */
    haddleSelect(item) {
      this.list_over = false
      if(item === 'all'){
        _czc.push(['_trackEvent', '首页(新)', '左侧信息流可切换目录标签(全部文章)', '点击量'])
        return
      }
      this.content_ids = {}
      this.articleList = []
      this.entity5 = []

      if (item === '') {
        this.active_type = ''
        this.params.category_ids = []
        this.follow_page = 1
        this.getList()
        _czc.push(['_trackEvent', '首页(新)', '左侧信息流可切换目录标签(最新)', '点击量'])
      } else {
        this.active_type = item.id
        this.params.category_ids = [item.id]
        this.params.page = 1
        this.indexlist()
        let type = '左侧信息流可切换目录标签(' + item.name + ')'
        _czc.push(['_trackEvent', '首页(新)', type, '点击量'])
      }
    },
    /**
     * @description: 加载更多
     * @param {*}
     * @return {*}
     */
    more() {
      if (this.active_type === '') {
        ++this.follow_page
        this.getList()
      } else {
        ++this.params.page
        this.indexlist()
      }
    },
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */    
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
  },
  components: {
    // Guide,
    ThemePro,
    Entity5,
    Report,
    Article,
    Topic,
    Poster,
    TopicLive,
    LatestFinancing,
    DFinancing,
    RCtrack,
    Activetrack,
    RCreport,
    ReportChart,
    HotTag,
    HotArticle,
    Author,
    RightModel,
    Banner
  }

}
</script>

<style lang="stylus" scoped>
@import '~styles/main.stylus'
.over-p
  text-align: center
  color #ffc069
</style>